<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
        :readOnly="readOnly"
        :isLoss="isLoss"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isLoss: {
      type: Boolean,
      default: false,
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_EXIT_STORAGE_ADJUSTMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id,
            movementItemId: this.entry.movementItemId,
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.exitStorageAdjustment;
          this.editableEntry.isLoss = this.isLoss;
          console.log("this.editableEntry exit storage adjustment", this.editableEntry);
          console.log("crops", response.data.accountContext.allCropsForAdjustment);
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(exitStorageAdjustment) {
      this.pageLoading = true;
      if(!this.editableEntry.enabledLots){
        this.editableEntry.exitMovementItemsAttributes.forEach(
          function(item){
            delete item.exitMovementItemLotsAttributes;
          }
        );
      }
      // console.log("exa", exitStorageAdjustment);
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(exitStorageAdjustment, this.editableEntry.validations);
      this.$apollo
        .mutate({
          mutation: UPDATE_EXIT_STORAGE_ADJUSTMENT_MUTATION,
          variables: {
            input: filtered 
          }
        })
        .then(response => {
          var errors = response.data.updateExitStorageAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            // this.editableEntry.adjustmentTypeText = "Saída";
            // this.editableEntry.storage = this.extraData.accountContext.allStorages.filter(storage=> storage.id == this.entry.storageId)[0];
            this.editableEntry.entryMovementItemsAttributes = [];
            this.editableEntry.id = response.data.updateExitStorageAdjustment.stockAdjustment.id;
            this.$refs.baseEdit.closeDialog();
            // console.log("sa", response.data.updateExitStorageAdjustment.stockAdjustment);
            this.$emit("entry-updated", this.editableEntry);
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_EXIT_STORAGE_ADJUSTMENT_QUERY = gql `
query ($id: ID!, $movementItemId: ID) {
  accountContext {
    exitStorageAdjustment(id: $id) {
        id
        code
        date
        description
        removeFromStorage
        enabledLots
        isStockEntryType
        operationId
        movementItemId
        storageId
        storage {
          id
          name
        }
        stockAdjustmentReasonId
        stockAdjustmentReason {
          id
          name
        }
        exitMovementItemsAttributes {
          id
          quantity
          hasLot
          packagingQuantity
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
            typeText
          }
          packagingId
          packaging {
            id
            name
            unitName
            size
            text
          }
          validations
        }
        dummyExitMovementItemsAttributes {
          id
          quantity
          hasLot
          packagingQuantity
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
            typeText
          }
          packagingId
          packaging {
            id
            name
            unitName
            size
            text
          }
          validations
        }
        validations
      }
      allStorages {
        id
        name
        location
      }
      allGreenhouses{
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }
      allCropsForAdjustment(movementItemId: $movementItemId)
    }
  }
`;

const UPDATE_EXIT_STORAGE_ADJUSTMENT_MUTATION = gql `
  mutation($input: ExitStorageAdjustmentUpdateInputObject!) {
    updateExitStorageAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>